import type { Moment } from 'moment';
import moment from 'moment';

/**
 * Ant Design TimePicker disabledHours / disabledMinutes helpers that block
 * clock values after `now` (same calendar day).
 */
export const getDisabledFutureHours = (now: Date = new Date()): number[] => {
  const currentHour = moment(now).hour();
  const disabled: number[] = [];
  for (let hour = currentHour + 1; hour < 24; hour += 1) {
    disabled.push(hour);
  }
  return disabled;
};

export const getDisabledFutureMinutes = (
  selectedHour: number | null | undefined,
  now: Date = new Date(),
): number[] => {
  const nowMoment = moment(now);
  if (selectedHour == null || selectedHour !== nowMoment.hour()) {
    return [];
  }
  const currentMinute = nowMoment.minute();
  const disabled: number[] = [];
  for (let minute = currentMinute + 1; minute < 60; minute += 1) {
    disabled.push(minute);
  }
  return disabled;
};

/** Keep the selected moment on today's date while applying HH:mm from the picker. */
export const applyPickedTimeOnDate = (baseDate: Date, picked: Moment | null): Date | null => {
  if (!picked || !picked.isValid()) {
    return null;
  }
  const next = moment(baseDate);
  next.hour(picked.hour()).minute(picked.minute()).second(0).millisecond(0);
  return next.toDate();
};
